import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17c790d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sw-top-page" }
const _hoisted_2 = { class: "sw-top-page--container" }

import SwDefaultTemplate from '@/components/templates/SwDefaultTemplate.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SwTopPageTemplate',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwDefaultTemplate, null, {
    main: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "app-header"),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "carousel"),
          _renderSlot(_ctx.$slots, "announcement"),
          _renderSlot(_ctx.$slots, "banner"),
          _renderSlot(_ctx.$slots, "work-navigation"),
          _renderSlot(_ctx.$slots, "new-works"),
          _renderSlot(_ctx.$slots, "popular-works"),
          _renderSlot(_ctx.$slots, "popular-tags"),
          _renderSlot(_ctx.$slots, "latest-requestment")
        ]),
        _renderSlot(_ctx.$slots, "app-footer")
      ])
    ]),
    _: 3
  }))
}
}

})